import { render, staticRenderFns } from "./StockRevisionLotsDialog.vue?vue&type=template&id=1bc8770f"
import script from "./StockRevisionLotsDialog.vue?vue&type=script&lang=js"
export * from "./StockRevisionLotsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports